// import localForage from 'localforage';
import storage from 'redux-persist/es/storage';

const storeConfig = {
    // blacklist: ['websocket', 'domainData', 'datetime'],
    key: 'systemx-lt-',
    storage,
};

export default storeConfig;



// WEBPACK FOOTER //
// ./src/common/config/store.js